import { action } from 'easy-peasy';
import { IActionSetCounters } from '../types';

const setCounters: IActionSetCounters = action((state, payload) => {
  state.counters = payload;
});

export default setCounters;
